/**
 * Update document title and meta tags for SEO
 * @param {Object} options - SEO options
 * @param {string} options.title - Page title
 * @param {string} options.description - Meta description
 * @param {string} options.keywords - Meta keywords
 * @param {string} options.url - Canonical URL
 */
export const updateSEO = ({ title, description, keywords, url }) => {
  // Update title
  if (title) {
    document.title = title
  }

  // Update or create meta description
  let metaDescription = document.querySelector('meta[name="description"]')
  if (!metaDescription) {
    metaDescription = document.createElement('meta')
    metaDescription.setAttribute('name', 'description')
    document.head.appendChild(metaDescription)
  }
  if (description) {
    metaDescription.setAttribute('content', description)
  }

  // Update or create meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]')
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta')
    metaKeywords.setAttribute('name', 'keywords')
    document.head.appendChild(metaKeywords)
  }
  if (keywords) {
    metaKeywords.setAttribute('content', keywords)
  }

  // Update or create canonical URL
  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  if (url) {
    canonical.setAttribute('href', url)
  }

  // Update Open Graph tags
  updateOGTag('og:title', title)
  updateOGTag('og:description', description)
  updateOGTag('og:url', url)
}

/**
 * Update or create Open Graph meta tag
 * @param {string} property - OG property name
 * @param {string} content - Content value
 */
const updateOGTag = (property, content) => {
  if (!content) return

  let tag = document.querySelector(`meta[property="${property}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

